module.exports = __webpack_public_path__ + "img/stamp_good_on.fa8f8908.svg";